import { useMemo } from "react"
import styles from "./GraphUrgentLow.module.scss"
import { useGetMgdlAsTopPosition } from "./useGetMgdlAsTopPosition"
import { useFollowedUsers } from "src/contexts"

export function GraphUrgentLow() {
  const { currentFollow } = useFollowedUsers()
  const displaySettings = currentFollow.display_settings
  const getMgdlAsTopPosition = useGetMgdlAsTopPosition()
  const [
    topPosition,
    clamped,
  ] = getMgdlAsTopPosition(displaySettings.urgent_low)

  const urgentLowStyles = useMemo(
    () => ({
      top: topPosition,
    }),
    [topPosition],
  )

  if (clamped) {
    return null
  }

  return (
    <div
      id="urgent-low-line"
      className={styles.urgentLow}
      style={urgentLowStyles}
    />
  )
}
